import { FC } from 'react';
import { IDevelopmentChallenges } from '@components/projects/level01/level01.state';
import FAQ from '@components/shared/blocks/faq';
import Level01Animation from '@components/projects/level01/animations';
import animations from '@components/projects/level01/animations/animations.module.scss';


type FAQSectionProps = {
  section: IDevelopmentChallenges;
}

const FAQSection: FC<FAQSectionProps> = ({section}) => {
  return <Level01Animation render={(ref) => (
    <div ref={ref} className={animations.scroll__animation}>
      <FAQ title={section.title} itemsFAQ={section.accordionItems} hoverColor={'grey'}/>
    </div>
  )}/>;
}

export default FAQSection;
